/* eslint-disable max-len */

export default {
  lang: 'English',
  homeScreen: {
    title: 'Share Our Passion', // Product specific
    stayConnected: 'Stay Connected',
    comingSoon: 'Coming Soon',
    messages: 'Messages',
  },
  loginScreen: {
    title: 'Travel Professional Training and Sales Enablement Program', // Product specific (TravPRO text or ChannelPRO text)
    welcome: {
      headerTop: 'Welcome to the',
      headerBottom: 'Canada Specialist Program', // Product specific
    },
    sellingPoints: {
      // All selling points can be product specific
      0: 'Learn, Promote & Sell on the Go',
      1: 'Multi-media Training Across Devices',
      2: 'Certificate of Completion',
      3: 'Ready-made Sales Presentations',
      4: 'High-impact Promotional Materials',
      5: 'Insider Tips & Promotions',
      6: 'Real-time Product Directory',
      7: 'Timely News & Updates',
    },
    emailPrompt: 'Please enter your email address and password to confirm that you are a travel professional.', // Product specific (TravPRO or ChannelPRO text)
    tAndC: {
      agree: 'By continuing you agree with our ',
      privacyPolicy: 'privacy policy',
      and: ' and ',
      termsConditions: 'terms and conditions',
    },
    fields: {
      forgot:
        'Please provide the email address that you used when you signed up for your Canada Specialist Program account. We will send you an email that will allow you to reset your password.',
      agency: 'Agency',
      email: 'Email',
      password: 'Password',
      passwordConfirm: 'Confirm your password',
      firstName: 'First name',
      lastName: 'Last name',
      address: 'Address',
      postalCode: 'Zip Code',
      city: 'City',
      agencyName: 'Agency Name',
      stateProvince: 'State / Province',
      required: 'Required',
      invalidEmail: 'Invalid email address',
      opt: "Stay In Touch! Yes, I'd like to opt in to communications from Destionation Canada that will keep me posted on news, events, incentives, FAM’s and more!",
    },
    noAgent: {
      noAgentButton: "I'm not an agent",
      title: 'Thank you for your interest in the Canada Specialist Program.', // Product specific
      messageWeb:
        'The content on this site is exclusively for travel professionals. \n To learn more about Canada, please visit: ', // Product specific
      messageMobile:
        "Some content on this app is exclusively for travel professionals, but feel free to browse a preview of what this app has to offer by pressing 'Continue'.", // Product specific
      continue: 'Continue',
      visitWebsite: 'Visit website',
    },
    newUser: 'New User',
    register: 'Register',
    registered: 'This email is already registered',
  },
  welcomeScreen: {
    title: 'Welcome to the Canada Specialist Program', // Product specific
    helloUser: 'Hello {{name}}',
    hello: 'Hello,',
    fromAgency: 'from {{agency}}',
    notUser: 'Not {{name}}?',
    introOnline: "Train immediately online or preload the content so it's always available for offline use!",
    introOffline: 'You already have the latest version preloaded. Start training or selling anytime, anywhere!',
    startTraining: 'Start learning',
    continueTraining: 'Continue learning',
    graduated: 'Congratulations!',
    downloader: {
      preload: 'Preload',
      stop: 'stop',
      init: 'Initializing...',
      lastUpdate: 'Last update: ',
    },
  },
  trainingScreens: {
    allUnlocked: 'You have unlocked all chapters!',
    certificate: 'Certificate',
    chapter: 'Chapter',
    chapterComplete: 'Chapter complete!',
    choose: 'Please choose an answer',
    confirm: 'Confirm your answer',
    continue: 'Continue',
    welcome:
      'Simply complete modules to gain points towards your ultimate goal of becoming a Gold Canada Specialist. The bar along the right will show you exactly how you’re doing.',
    courseComplete: 'Course complete!',
    durationInMinutes: '{number} minutes',
    endReached: "You've reached the end",
    essential: 'The Foundation',
    essentialSub: 'Complete these essential modules to earn bronze status.',
    message: '{count} STAR Message',
    messagePlural: '{count} STAR Messages',
    percentageComplete: '{number}% Complete',
    restart: 'Restart',
    retainEnd: 'Use the top bar to navigate around in this chapter or press the back button to return to the overview.',
    retry: 'Try Again',
    skip: 'Return >',
    viewAllTitle: 'Training Tip',
    viewAll:
      'In order to proceed to the next page, please click on the icons to view the supplementary content. Videos, maps and other helpful information have been provided to enhance your training and ensure you achieve PRO status.',
    specialization: 'Specialization Modules',
    specializationSub: 'Finish these modules to Achieve Your Silver Canada Specialist Status',
    start: 'Start',
    review: 'Review',
    status: 'Current Status:',
    tip: 'You earn your status by completing<br />the modules within each tier. <br />Dream big and reach Gold Canada Specialist status<br />by completing all modules!',
    trouble: "It looks like you're having trouble, please re-read the content on the previous page(s) and try again.",
    unlock: 'Unlock this chapter by completing training chapter {number}.',
    unlockSubtitle: 'Unlock more chapters by completing training chapters.',
    watchListenRead: 'Watch, Listen & Read more',
  },
  newTrainingFlow: {
    tip: 'tip: You earn your status by completing the modules within each tier.  Dream big and reach Gold Canada Specialist status by completing all modules!',
    essentialModules: 'Essential Modules',
    finishBronze: 'Finish these modules to Earn Your Bronze Canada Specialist Status',
    specializationModules: 'Specialization Modules',
    finishSilver: 'Finish these modules to Achieve Your Silver Canada Specialist Status',
    partnerModules: 'Partner Modules',
    finishGold: 'Finish these modules to Achieve Your Gold Canada Specialist Status',
    currentStatus: 'Current Status',
    pointsToLevel: '{pointsToLevel} {points} ',
    reachedRanking: 'until you have reached the {rank} ranking!',
    outOf: '{points} XP out of',
    pointsToRank: '{pointsToLevel} XP needed to rank:  ({rank})',
  },
  points: {
    pointsToLevel: '{pointsToLevel} {points} until you have reached the {rank} ranking!',
    outOf: '{points} XP out of',
    unit: 'XP',
    pointsToRank: '{pointsToLevel}XP needed to rank:  ({rank})',
    complete: {
      chapter: 'Chapter complete!',
      'intro-chapter': 'Intro Chapter complete!',
      'sub-app': 'SubApp complete!',
      rewards: 'Rewards complete!',
      multi: "You're due some points!",
    },
    completed: '{completed} / {total} Completed',
  },
  nav: {
    home: 'Home',
    train: 'Learn',
    learn: 'Learn',
    retain: 'Retain',
    directory: 'Directory',
    showRoom: 'Hotel Spotlights',
    showcases: 'Hotel Spotlights',
    promote: 'Promote',
    sell: 'Sell',
    info: 'Info',
    rewards: 'Rewards',
    media: 'Media',
    favorites: 'Favorites',
    contact: 'Contact',
    reportCard: 'View Diploma',
    accountSettings: 'Account Settings',
    messages: 'Messages',
    search: 'Search',
  },
  contentHeaders: {
    train: 'Learn',
    retain: 'Retain',
    subapps: 'The Provinces',
    maintrainings: 'The Foundation',
    subtrainings: 'The Experience',
  },
  pageDescriptions: {
    train: 'Educate, engage and become the expert.',
    showroom: '',
    retain:
      'Your go-to resource for retaining your expert knowledge and enabling your sales efforts. Use this area to expertly answer a product question or even as an impromptu sales presentation — anytime, anywhere and from any device.',
    promote: 'Start the conversation with your clients and prospects.',
    sell: 'Answer client questions and close the sale.',
    favorites: 'Check out your personally favorited content',
    search: 'Look through all content',
    subapps: 'Complete eight province modules and you achieve GOLD status!',
    maintrainings: 'Complete the foundation modules to earn your diploma.',
    subtrainings: 'Dive into Canada’s many distinct experiences and achieve silver status.',
  },
  general: {
    forgot: 'Forgot Password?',
    next: 'Next',
    yes: 'Yes',
    no: 'No',
    previous: 'Previous',
    submit: 'Submit',
    register: 'Register',
    back: 'Back',
    close: 'Close',
    page: 'Page',
    search: 'Search',
    searchBarPlaceholder: 'Search Canada Specialist Program',
    logIn: 'Log in',
    logOut: 'Log Out',
    viewItem: 'View {type}',
    imageNotFound: 'Image not found',
    noResults: 'No results found.',
    noResultsFor: 'No results have been found for: {{query}}',
    noFavorites: "You don't have any favorites yet.",
    noMessages: "You haven't received any messages yet!",
    resultsFor: 'Results for: {{query}}',
    showAll: 'Show all',
    connectionError: 'Connection error',
    alreadyExists: 'Already exists',
    pageNotFound: '404 Page Not Found!',
    oops: 'Uh oh...',
    overview: 'Return to overview',
    complete: 'Continue',
    courseComplete: 'Chapter Complete!',
    chapterComplete: 'Chapter Completed!',
    message: '{count} Message',
    messagePlural: '{count} Messages',
  },
  itemTypes: {
    image: 'Image',
    brochure: 'Collection',
    layout: 'Layout',
    web: 'Website',
    pdf: 'PDF',
    carousel: 'Collection',
  },
  questions: {
    dials: 'Rotate the dials to match the answer',
    fitb: 'Fill in the blank(s)',
    flip: 'Change the number to match the answer',
    multipleChoice: 'Pick the right answer(s)',
    slider: 'Pick the right answer using the slider',
    map: 'Answer the question by tapping the right location on the map',
    dropdown: 'Choose...',
    true: 'True',
    false: 'False',
  },
  reportCard: {
    download: 'Download',
    email: 'Email',
    print: 'Print',
  },
  filters: {
    SCI: 'Sales Item',
    links: 'links',
  },
  cookies: {
    consent: 'AGREE',
    optout: 'Opt-out',
    settings: 'Privacy Settings',
    message:
      "You haven't told us anything about your data privacy preferences! That's ok, but we'd like to offer you the best experience using the Sales Companion.",
    disabled: 'It looks like you have disabled the use of cookies.',
    use: 'The {{appName}} requires the use of cookies to deliver you the best experience.',
    details: 'What are the cookies used for?',
    enable: 'See how to enable your cookies {{here}}.',
    here: 'here',
  },
  notLoggedIn: {
    super: "You're not logged in",
    title: 'You need to be logged in to view this content',
    guest: 'Guest',
  },
  demo: {
    message: 'This website is a demo of the final product. It is currently in-development and not a complete product.',
    consent: 'Understood!',
  },
  share: {
    header: 'Share this resource on your favorite social media!',
    download: 'Download',
  },
  sharing: {
    copyURL: 'Copy Link',
    copied: 'Copied',
  },
  breadCrumbs: {
    page: 'Page',
  },
  onMobile: {
    header: "It looks like you're trying to access the {appName} app from a mobile device",
    body: 'To download this program simply visit your app store and search for {appName} or click one of the buttons below',
    benefits: {
      header: 'This will provide you with:',
      1: 'Learn, Promote & Sell on the Go',
      2: 'Multi-media Training Across Devices',
      3: 'Certificate of Completion',
      4: 'Ready-made Sales Presentations',
      5: 'High-impact Promotional Materials',
      6: 'Real-time Product Directory',
      7: 'Timely News & Updates',
    },
  },
  custom: {
    splitUsers: 'I Am A ...',
    brandAmbassador: 'Brand Ambassador',
    travelPro: 'Travel Professional',
  },
};
